export const GameTeamStatusType = {
    ALL: {
        id: "ALL",
        title: "همه"
    },
    ACTIVE: {
        id: "ACTIVE",
        title: "فعال"
    },
    FORMING: {
        id: "FORMING",
        title: "ساخته شده"
    },
    DISBANDED: {
        id: "DISBANDED",
        title: "منحل شده"
    },
    DISQUALIFIED: {
        id: "DISQUALIFIED",
        title: "رد صلاحیت شده"
    },
}

export function getGameTeamStatus(status) {
    switch (status) {
        case GameTeamStatusType.ACTIVE.id: {
            return GameTeamStatusType.ACTIVE.title
        }
        case GameTeamStatusType.FORMING.id: {
            return GameTeamStatusType.FORMING.title
        }
        case GameTeamStatusType.DISBANDED.id: {
            return GameTeamStatusType.DISBANDED.title
        }
        case GameTeamStatusType.DISQUALIFIED.id: {
            return GameTeamStatusType.DISQUALIFIED.title
        }
    }
}